interface LocalesConfig {
    cn: string;
    en: string;
}

interface SystemConfig {
    title: string;
    tokenHomeName: string;
    authHomeName: string;
    notLoginPage: string[];
    career: LocalesConfig;
    industry: LocalesConfig;
    scope: LocalesConfig;
    fbccLogin: LocalesConfig;
    fbccArea: LocalesConfig;
    fbccType: LocalesConfig;
    fbccAccount: LocalesConfig;
    tokenKey: string;
    platformConfig: string;
    messengerPageKey: string;
    messengerSessionKey: string;
    chatPluginKey: string;
    chatPluginSessionKey: string;
    chatAssignKey: string;
    chatTabValue: string;
    chatFilterMore: string;
    chatFilterViewId: string;
    chatFilterViewShrink: string;
    chatUserQuery: string;
    chatFilterType: string;
    chatSortType: string;
    chatFilterChannel: string;
    chatFilterAccounts: string;
    chatFilterActiveChannel: string;
    chatUserGotoMetaTips: string;
    chatUnsentMessageCache: string;
    siteConfig: {
        [index: string]: any;
    };
    coinifyPayTypes: string[];
    localPromotionActivityModalKey: string;
    localPromotionActivityBarKey: string;
    chatAvatarBackgroundColors: {
        [index: string]: string;
    },
    splitListChannelKey: string;
    whatsappTemplateGuideCloseKey: string;
    certifyNoticeTopKey: string;
    certifyNoticeChatKey: string;
    pageSizeRecord: 'ALLLIST_PAGESIZERECORD';
    createAutomationFlowChannelKey: string;
    channelsWhatsAppGuideSkipKey: string;
    flowConditionScheduleSplitTime: number;
    latestSystemMessageIDKey: string;
    chatMemberMultipleGroupEnumKey: string;
    chatMemberMultipleKey: string;
    chatAssignListKey: string;
    recordEvaluate: string;
    fastSearchWayKey: string;
    isoCode: string;
    broadcastConfigKey: string;
    broadcastCyclePlanGuideKey: string;
    contactViewListConfigKey: string;
    contactViewListShowStatusKey: string;
    newTranslateWayTipsKey: string;
    aiLanguageDetectionTipsKey: string;
    autoChangeToAIDetectKey: string;
    firstUseSmartReplyKey: string;
    // [key: string]: any;
}

// const hostName = window.location.hostname;
const siteConfig = window.__siteConfig || {
    defineLogo: false,
    title: 'SaleSmartly',
    brand: false,
};

const config: SystemConfig = {
    /**
     * @description 配置显示在浏览器标签的title
     */
    title: siteConfig.title,
    tokenKey: 'LOCAL_KEY_IN_WEBSITE',
    siteConfig,
    /**
     * @description 默认打开的首页的路由name值
     */
    tokenHomeName: 'tokenMode_token',
    authHomeName: 'channels_messenger_auth',
    notLoginPage: [
        'login',
        'registration',
        'registrationSuccess',
        'activeUser',
        'exclusive',
        'reset',
        'privacy',
        'invite',
        'open',
        'openInfo',
        'forgetpassword',
        'payresult',
        'authShoplazza',
        'bigcommerceTransit',
        'authThird',
        'automatedLinks',
        'authWorkWeixin',
        'authWorkWeixinTest',
        // 'share',
        'shareVerify',
        'shareVerifyChannel',
        'shareVerifyCustomer',
        'shareAnalysis',
        'shareLinkChannelAnalysis',
        'shareLinkCustomerAnalysis',
        // 第三方sso
        'authSSO',
        'authSSOFailed',
    ],
    /**
     * @description 职业
     */
    career: {
        cn: 'SELECTOR_JOB_LIST_CN',
        en: 'SELECTOR_JOB_LIST_EN',
    },
    /**
     * @description 行业
     */
    industry: {
        cn: 'SELECTOR_INDUSTRY_LIST_CN',
        en: 'SELECTOR_INDUSTRY_LIST_EN',
    },
    /**
     * @description 规模
     */
    scope: {
        cn: 'COMPANY_SCOPE_LIST_CN',
        en: 'COMPANY_SCOPE_LIST_EN',
    },
    /**
     * @description 登录状态
     */
    fbccLogin: {
        cn: 'FBCC_LOGIN_STATUS_LIST_CN',
        en: 'FBCC_LOGIN_STATUS_LIST_CN',
    },
    /**
     * @description 货币单位
     */
    fbccArea: {
        cn: 'FBCC_USER_AREA_LIST_CN',
        en: 'FBCC_USER_AREA_LIST_CN',
    },
    /**
     * @description 账号类型
     */
    fbccType: {
        cn: 'FBCC_USER_TYPE_LIST_CN',
        en: 'FBCC_USER_TYPE_LIST_CN',
    },
    fbccAccount: {
        cn: 'FBCC_ACCOUNT_STATUS_LIST_CN',
        en: 'FBCC_ACCOUNT_STATUS_LIST_CN',
    },
    platformConfig: 'PLATFORM_CONFIG',
    messengerPageKey: 'MESSENGER_PAGE',
    messengerSessionKey: 'MESSENGER_PAGE_USER',
    chatPluginKey: 'CHAT_PLUGIN',
    chatPluginSessionKey: 'CHAT_PLUGIN_USER',
    chatAssignKey: 'CHAT_ASSIGN_ID',
    chatTabValue: 'CHAT_TAB_VALUE',
    chatFilterMore: 'CHAT_FILTER_MORE',
    chatFilterViewId: 'CHAT_FILTER_VIEW_ID',
    chatFilterViewShrink: 'CHAT_FILTER_VIEW_SHRINK',
    chatUserQuery: 'CHAT_USER_QUERY',
    chatFilterType: 'CHAT_FILTER_TYPE',
    chatSortType: 'CHAT_SORT_TYPE',
    chatFilterChannel: 'CHAT_FILTER_CHANNEL',
    chatFilterAccounts: 'CHAT_FILTER_ACCOUNTS',
    chatFilterActiveChannel: 'CHAT_FILTER_ACTIVE_CHANNEL',
    chatUserGotoMetaTips: 'CHAT_USER_GOTO_META_TIPS',
    chatUnsentMessageCache: 'CHAT_UNSENT_MESSAGE_CACHE',
    coinifyPayTypes: ['coinify_usdt_trc20', 'coinify_btc', 'coinify_eth', 'coinify_usdc'],
    /* 促销活动 local key start */
    localPromotionActivityModalKey: 'LOCAL_RECOUP_2025_11_MODAL_KEY',
    localPromotionActivityBarKey: 'LOCAL_PROMOTION_2025_06_END_BAR_KEY',
    /* 促销活动 local key end */
    chatAvatarBackgroundColors: {
        0: '#8C88CD',
        1: '#F26D66',
        2: '#78CB7A',
        3: '#69C5E4',
        4: '#6B95FF',
        5: '#FFC168',
    },
    splitListChannelKey: 'SPLIT_LINK_CHANNEL_KEY',
    whatsappTemplateGuideCloseKey: 'WS_TMP_GUIDE_CLOSE',
    /* 实名认证start */
    certifyNoticeTopKey: 'CERTIFY_NOTIFY_TOP_KEY',
    certifyNoticeChatKey: 'CERTIFY_NOTIFY_CHAT_KEY',
    /* 实名认证end */

    pageSizeRecord: 'ALLLIST_PAGESIZERECORD',
    createAutomationFlowChannelKey: 'CREATE_AUTOMATION_FLOW_CHANNEL',
    channelsWhatsAppGuideSkipKey: 'WHATSAPP_GUIDE_SKIP',
    flowConditionScheduleSplitTime: 15,

    latestSystemMessageIDKey: 'LATEST_SYSTEM_MESSAGE_ID',

    // 聊天多选分组枚举key
    chatMemberMultipleGroupEnumKey: 'CHAT_MEMBER_MULTIPLE_GROUP_ENUM_KEY',
    // 聊天多选成员key
    chatMemberMultipleKey: 'CHAT_MEMBER_MULTIPLE_KEY',
    chatAssignListKey: 'CHAT_ASSIGN_LIST_KEY',
    recordEvaluate: 'CHAT_RECORD_EVALUATE',
    // 聊天快速筛选
    fastSearchWayKey: 'CHAT_FAST_SEARCH_WAY_KEY',

    // 用户手机号区号
    isoCode: 'CHAT_PHONE_ISO_CODE',

    // 消息群发配置
    broadcastConfigKey: 'BROADCAST_CONFIG_KEY',
    broadcastCyclePlanGuideKey: 'BROADCAST_CYCLE_PLAN_GUIDE_KEY',

    // 客户列表视图配置
    contactViewListConfigKey: 'CONTACT_VIEW_LIST_CONFIG_KEY',
    // 客户列表视图显示状态配置
    contactViewListShowStatusKey: 'CONTACT_VIEW_LIST_SHOW_STATUS_KEY',

    // 翻译方式上新提示
    newTranslateWayTipsKey: 'NEW_TRANSLATE_WAY_TIPS_KEY',
    // 翻译方式上新提示缓存key
    aiLanguageDetectionTipsKey: 'AI_LANGUAGE_DETECTION_TIPS_KEY',
    autoChangeToAIDetectKey: 'AUTO_CHANGE_TO_AI_DETECT_KEY',
    firstUseSmartReplyKey: 'CHAT_FIRST_USE_SMART_REPLY',
};
export default config;
